import React, { useEffect, useState } from "react";
import { currentAssessmentState, networkConnectionStatus } from "../data/atoms";
import { useRecoilState } from "recoil";
import { useHistory } from "react-router";
import { TestType } from "../models/Enums";

interface Props {
  tableData: any[];
  assessements: [];
  show: boolean;
  lookupid: number;
  isIncompleteAssessment?: boolean;
}

const AssessmentInfoTable: React.FC<Props> = ({
  tableData,
  assessements,
  show,
  lookupid,
  isIncompleteAssessment,
}) => {
  const [currentAssessment, setcurrentAssessmentState] = useRecoilState(
    currentAssessmentState,
  );
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [tableDateToDisplay, setTableDateToDisplay] = useState<any>([]);

  function removeSwayMeasure(data: any): any {
    let filteredData = data.map((item: any) => {
      const filteredRows = item.rows.filter((row: any) => {
        const measure = row.Measure || row.measure;
        const score = row.Score || row.score;

        if (measure === "Sway (cm)") return false;
        if (measure === "Cadence (steps/min)") return false;
        if (measure === "Forward Lean (deg)") return false;

        if (measure === "Mobility Level" && score === "ULTRALOW") {
          row.score = "LOW";
          row.Score = "LOW";
        }

        return true;
      });

      return {
        ...item,
        rows: filteredRows,
      };
    });

    return filteredData;
  }

  const formatNumber = (value: number): string => {
    return Number.isInteger(value) ? value.toString() : value.toFixed(2);
  };

  function calculatePercentage(data: any): any {
    let filteredData = data.map((item: any) => {
      debugger;

      const filteredRows = item.rows.filter((row: any) => {
        if (
          row.Measure === "Good Apple Percentage Caught (%)" ||
          row.Measure === "Bad Apple Percentage Caught (%)"
        ) {
          const score = parseFloat(row.Score); // Convert string to number
          if (!isNaN(score)) {
            row.Score = formatNumber(score * 100);
          }
          return "0"; // Default value if conversion fails
        }
        return true;
      });
      return {
        ...item,
        rows: filteredRows,
      };
    });

    return filteredData;
  }

  function calculateTugMobility(data: any): any {
    let filteredData = data.map((item: any) => {
      let updatedRows = [...item.rows];

      // Find the TUG time row
      const timeRow = updatedRows.find(
        (row: any) => row.Measure === "Total Time",
      );

      if (timeRow) {
        const time = parseFloat(timeRow.Score) / 1000;

        let mobilityStatus = "";

        if (isIncompleteAssessment) {
          mobilityStatus = "Low (Incomplete assessment)";

          // Remove the Total Time row and any existing Mobility rows
          updatedRows = updatedRows.filter(
            (row: any) =>
              row.Measure !== "Total Time" && row.Measure !== "Mobility",
          );

          // Add mobility row
          updatedRows.push({
            Measure: "Mobility",
            Score: mobilityStatus,
          });
        } else {
          if (!isNaN(time)) {
            // Calculate mobility based on TUG time ranges
            if (time >= 14) {
              mobilityStatus = "Low";
            } else if (time < 14 && time >= 10) {
              mobilityStatus = "Medium";
            } else if (time < 10) {
              mobilityStatus = "High";
            } else {
              mobilityStatus = "High";
            }

            // Remove the Total Time row and any existing Mobility rows
            updatedRows = updatedRows.filter(
              (row: any) =>
                row.Measure !== "Total Time" && row.Measure !== "Mobility",
            );

            // Add mobility row
            updatedRows.push({
              Measure: "Mobility",
              Score: mobilityStatus,
            });
          }
        }
      }

      // Format all numeric scores to 2 decimal places
      updatedRows = updatedRows.map((row: any) => {
        const numericScore = parseFloat(row.Score);
        if (!isNaN(numericScore) && row.Measure !== "Mobility") {
          return {
            ...row,
            Score: formatNumber(numericScore),
          };
        }
        return row;
      });

      // Reorder rows: Mobility first, Cadence last, others in between
      const mobilityRow = updatedRows.find(
        (row: any) => row.Measure === "Mobility",
      );
      const cadenceRow = updatedRows.find(
        (row: any) => row.Measure === "Cadence (steps/min)",
      );
      const otherRows = updatedRows.filter(
        (row: any) =>
          row.Measure !== "Mobility" && row.Measure !== "Cadence (steps/min)",
      );

      updatedRows = [
        ...(mobilityRow ? [mobilityRow] : []),
        ...otherRows,
        ...(cadenceRow ? [cadenceRow] : []),
      ];

      return {
        ...item,
        rows: updatedRows,
      };
    });

    return filteredData;
  }

  function calculateFunctionalReachMobility(value: any): any {
    let mobilityStatus = "";
    if (!isNaN(value)) {
      if (value > 10) {
        mobilityStatus = "High";
      } else if (value <= 10 && value >= 6) {
        mobilityStatus = "Medium";
      } else if (value < 6) {
        mobilityStatus = "Low";
      } else {
        mobilityStatus = "";
      }
      return mobilityStatus;
    }
  }

  function changeVeggieSlicersColumn(data: any): any {
    let filteredData = data.map((item: any) => {
      const filteredRows = item.rows.filter((row: any) => {
        if (row.Measure === "score") {
          row.Measure = "Score";
        } else if (row.Measure === "scorePerMinute") {
          row.Measure = "Score Per Minute";
        } else if (row.Measure === "veggies_cut") {
          row.Measure = "Veggies Cut";
        } else if (row.Measure === "veggies_missed") {
          row.Measure = "Veggies Missed";
        } else if (row.Measure === "sponges_cut") {
          row.Measure = "Sponges Cut";
        }
        return true;
      });
      return {
        ...item,
        rows: filteredRows,
      };
    });

    return filteredData;
  }

  function formatFunctionalReachTables(data: any): any {
    let formattedData: any[] = [];

    data.forEach((item: any) => {
      // Find the rows
      const forwardReach = item.rows.find(
        (row: any) => row.Measure === "Forward Reach",
      );
      const lateralReachLeft = item.rows.find(
        (row: any) => row.Measure === "Lateral Reach (Left)",
      );
      const lateralReachRight = item.rows.find(
        (row: any) => row.Measure === "Lateral Reach (Right)",
      );
      const mobility = item.rows.find((row: any) => row.Measure === "Mobility");

      // First table: Measure & Score (Mobility and Forward Reach)
      const firstTable: any = {
        name: "",
        columns: [{ ColumnNames: "Measure" }, { ColumnNames: "Score" }],
        rows: [],
      };

      if (mobility) {
        firstTable.rows.push({
          Measure: "Mobility",
          Score: calculateFunctionalReachMobility(forwardReach?.Score),
        });
      }

      if (forwardReach) {
        firstTable.rows.push({
          Measure: "Forward Reach (in)",
          Score: forwardReach?.Score,
        });
      }

      // Second table: Measure, Left & Right (Lateral Reach)
      const secondTable = {
        name: "",
        columns: [
          { ColumnNames: "Measure" },
          { ColumnNames: "Left" },
          { ColumnNames: "Right" },
        ],
        rows: [] as any[],
      };

      if (lateralReachLeft && lateralReachRight) {
        secondTable.rows.push({
          Measure: "Lateral Reach (in)",
          Left: lateralReachLeft.Score,
          Right: lateralReachRight.Score,
        });
      }

      formattedData.push(firstTable);
      formattedData.push(secondTable);
    });

    return formattedData;
  }

  function formatMctsibTables(data: any): any {
    debugger;
    console.log("formatMctsibTables called with data:", data);
    let formattedData: any[] = [];

    data.forEach((item: any) => {
      console.log("Processing mCTSIB item:", item);
      console.log("Item rows:", item.rows);

      // Find the rows for mCTSIB scores
      const visualScore = item.rows.find(
        (row: any) =>
          row.Measure === "Visual Score" ||
          row.measure === "Visual Score" ||
          row.Measure === "visual" ||
          row.measure === "visual",
      );
      const somatosensoryScore = item.rows.find(
        (row: any) =>
          row.Measure === "Somatosensory Score" ||
          row.measure === "Somatosensory Score" ||
          row.Measure === "somatosensory" ||
          row.measure === "somatosensory",
      );
      const vestibularScore = item.rows.find(
        (row: any) =>
          row.Measure === "Vestibular Score" ||
          row.measure === "Vestibular Score" ||
          row.Measure === "vestibular" ||
          row.measure === "vestibular",
      );
      const compositeScore = item.rows.find(
        (row: any) =>
          row.Measure === "Composite Score" ||
          row.measure === "Composite Score" ||
          row.Measure === "overall" ||
          row.measure === "overall" ||
          row.Measure === "composite" ||
          row.measure === "composite",
      );

      console.log("Found scores:", {
        visualScore,
        somatosensoryScore,
        vestibularScore,
        compositeScore,
      });

      // Create mCTSIB table: Measure & Score
      const mctsibTable: any = {
        name: "",
        columns: [{ ColumnNames: "Measure" }, { ColumnNames: "Score" }],
        rows: [],
      };

      // Add rows in the order shown in the image: Visual, Somatosensory, Vestibular, Composite
      if (visualScore) {
        mctsibTable.rows.push({
          Measure: "Visual Score",
          Score: Math.round(visualScore.Score || visualScore.score || 0),
        });
      }

      if (somatosensoryScore) {
        mctsibTable.rows.push({
          Measure: "Somatosensory Score",
          Score: Math.round(
            somatosensoryScore.Score || somatosensoryScore.score || 0,
          ),
        });
      }

      if (vestibularScore) {
        mctsibTable.rows.push({
          Measure: "Vestibular Score",
          Score: Math.round(
            vestibularScore.Score || vestibularScore.score || 0,
          ),
        });
      }

      if (compositeScore) {
        mctsibTable.rows.push({
          Measure: "Composite Score",
          Score: Math.round(compositeScore.Score || compositeScore.score || 0),
        });
      }

      console.log("Created mCTSIB table:", mctsibTable);
      formattedData.push(mctsibTable);
    });

    console.log("formatMctsibTables returning:", formattedData);
    return formattedData;
  }

  useEffect(() => {
    console.log("AssessmentInfoTable: lookupid =", lookupid, TestType.ctsib);
    console.log("AssessmentInfoTable: tableData =", tableData);

    setTableDateToDisplay(tableData);
    if (lookupid === TestType.gait) {
      let temp = removeSwayMeasure(tableData);
      setTableDateToDisplay(temp);
    } else if (lookupid === TestType.game_AF) {
      let temp = calculatePercentage(tableData);
      setTableDateToDisplay(temp);
    } else if (lookupid === TestType.veggie_samurai) {
      let temp = changeVeggieSlicersColumn(tableData);
      setTableDateToDisplay(temp);
    } else if (lookupid === TestType.tug) {
      let temp = calculateTugMobility(tableData);
      setTableDateToDisplay(temp);
    } else if (lookupid === TestType.reach) {
      // Functional reach tables are already in correct format, no reformatting needed
      setTableDateToDisplay(tableData);
    } else if (lookupid === TestType.ctsib) {
      console.log("Formatting mCTSIB table");
      let temp = formatMctsibTables(tableData);
      setTableDateToDisplay(temp);
    }
  }, [tableData]);

  let history = useHistory();

  const goToReportPage = (report: any) => {
    console.log("ViewAssessmentreport", report);
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setcurrentAssessmentState((prevState: any) => ({
      ...prevState,
      patientId: report.patientId,
      masterTestId: report.masterTestId,
      masterVisitId: report.masterVisitId,
      assessmentType: report.vbTestLookupId,
      testId: report.vbTestId,
      workstationId: report.workstationId,
      locationId: report.locationId,
      visitId: report.visitId,
      phaseId: 0,
      testJson: "",
      testDateTime: report.visitDate,
      isViewFullSummary: true,
    }));
    setTimeout(() => {
      history.replace("/patient-assessment-summary", {
        pageHeaderText: "Full Visit Summary",
        isAssessmentCompleted: false,
      });
    }, 200);
  };

  return (
    <div className="assessment-info-new-table">
      {tableDateToDisplay.map((table: any, index: any) => {
        return (
          <table
            key={index}
            className="table table-col-{{
                      table.Columns.length
                    }} table-border-0"
            aria-describedby="Assessment-Info-Table"
          >
            <thead className="table-head">
              <tr>
                {table.rows.length > 0 &&
                  table.columns.map((column: any, columnIndex: number) => {
                    return (
                      <th
                        key={columnIndex}
                        scope="col"
                        className="fz-16 fw-700"
                      >
                        {column.ColumnNames}
                      </th>
                    );
                  })}
              </tr>
            </thead>
            <tbody>
              {table.rows.map((row: any, rowIndex: number) => {
                if (
                  lookupid === TestType.upper_body_arom ||
                  (lookupid === TestType.reach &&
                    row.hasOwnProperty("Left") &&
                    row.hasOwnProperty("Right"))
                ) {
                  return (
                    <tr key={rowIndex}>
                      {
                        <>
                          <td className="fz-14 fw-600">
                            <span>
                              {row.hasOwnProperty("measure")
                                ? row.measure
                                : row.Measure}
                              {lookupid === TestType.upper_body_arom
                                ? " (°)"
                                : ""}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {row.hasOwnProperty("left") ? row.left : row.Left}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {row.hasOwnProperty("right")
                                ? row.right
                                : row.Right}
                            </span>
                          </td>
                        </>
                      }
                    </tr>
                  );
                } else {
                  return (
                    <tr key={rowIndex}>
                      {
                        <>
                          <td className="fz-14 fw-600">
                            <span>
                              {(row.hasOwnProperty("measure")
                                ? row.measure
                                : row.Measure) === "Gait Velocity (m/sec)"
                                ? "Gait Speed (m/sec)"
                                : (row.hasOwnProperty("measure")
                                      ? row.measure
                                      : row.Measure) === "Distance (m)"
                                  ? "Total Steps"
                                  : (row.hasOwnProperty("measure")
                                        ? row.measure
                                        : row.Measure) === "Average Speed (m/s)"
                                    ? "Steps per Second during Green Lights"
                                    : (row.hasOwnProperty("measure")
                                          ? row.measure
                                          : row.Measure) === "Meters Lost"
                                      ? "Number of Steps Lost"
                                      : row.hasOwnProperty("measure")
                                        ? row.measure
                                        : row.Measure}
                            </span>
                          </td>
                          <td className="fz-14 fw-600">
                            <span>
                              {row.hasOwnProperty("score")
                                ? row.score
                                : row.Score}
                            </span>
                          </td>
                        </>
                      }
                    </tr>
                  );
                }
              })}
              {table.rows.length > 0 &&
                !(lookupid === TestType.reach && index % 2 === 0) && (
                  <tr className="table-link-wrap">
                    <td colSpan={3}>
                      <span
                        className="table-link fz-16 fw-700"
                        onClick={() => {
                          goToReportPage(assessements);
                        }}
                      >
                        <svg
                          width="19"
                          height="18"
                          viewBox="0 0 19 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.4502 16.3125C14.7596 16.3125 15.0127 16.0594 15.0127 15.75V5.625H12.2002C11.5779 5.625 11.0752 5.12227 11.0752 4.5V1.6875H5.4502C5.14082 1.6875 4.8877 1.94062 4.8877 2.25V15.75C4.8877 16.0594 5.14082 16.3125 5.4502 16.3125H14.4502ZM3.2002 2.25C3.2002 1.00898 4.20918 0 5.4502 0H11.2686C11.8662 0 12.4393 0.235547 12.8611 0.657422L16.0428 3.83906C16.4646 4.26094 16.7002 4.83398 16.7002 5.43164V15.75C16.7002 16.991 15.6912 18 14.4502 18H5.4502C4.20918 18 3.2002 16.991 3.2002 15.75V2.25Z"
                            fill="#005A75"
                          />
                        </svg>
                        {lookupid === TestType.game_AF ||
                        lookupid === TestType.hec_training ||
                        lookupid === TestType.red_light_green_light ||
                        lookupid === TestType.veggie_samurai
                          ? "View Training"
                          : "View Assessment"}
                      </span>
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
        );
      })}
    </div>
  );
};
export default AssessmentInfoTable;
